import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "popup-footer" }
const _hoisted_6 = {
  key: 0,
  class: "loading-message"
}

import { useAdsStore } from "@/store/adsStore";
import { ref, computed, onMounted, onUnmounted } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdPopup',
  setup(__props) {

const ads = useAdsStore();
    const messages = ref<string[]>([
      '<a href="/plan" target="_blank">Paid plans</a> use the most accurate and powerful AI models available.',
      'Complete at least one lesson daily to keep a streak!',
      "Generating lessons and quizzes takes about 2-3× longer than regular replies. Thank you for your patience.",
      'Your ad could appear here.. <a href="/contact" target="_blank">get in touch.</a>',
      'Grow personally and professionally by making learning a fun part of your daily life.',
      'Would you recommend us to a friend? <br><a href="/contact" target="_blank">What could we do to make that happen?</a>',
      'Join our community on <a target="_blank" href="https://twitter.com/AscendanceCloud">𝕏</a> and <a target="_blank" href="https://discord.gg/33yAcp2qDf">Discord</a> to stay up-to-date with the latest features.',
      'Please consider <a target="_blank" href="https://donate.stripe.com/fZe8Ao9hl63qe9GeUX">donating</a> to help this app grow faster!',
    ]);
    const specialMessage = messages.value.splice(1, 1)[0];
    messages.value.sort(() => Math.random() - 0.5);
    messages.value.splice(1, 0, specialMessage);

    let messageIndex = ref<number>(0);
    const randomMessage = computed(() => messages.value[messageIndex.value]);

    const changeMessage = () => {
      messageIndex.value = (messageIndex.value + 1) % messages.value.length;
    };

    let messageInterval: ReturnType<typeof setInterval>;

    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Enter" && !ads.isLoading) {
        handleResponseClick();
      }
    };

    const handleResponseClick = () => {
      ads.hide();
    };

    onMounted(() => {
      messageInterval = setInterval(changeMessage, 7000);
      window.addEventListener("keydown", handleKeyPress);
    });

    onUnmounted(() => {
      clearInterval(messageInterval);
      window.removeEventListener("keydown", handleKeyPress);
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(ads).isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "emoji-indicator" }, "⌛", -1)),
                _createElementVNode("button", {
                  class: "close-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(ads).hide && _unref(ads).hide(...args)))
                }, "✖")
              ]),
              _createVNode(_Transition, {
                name: "fade-message",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: "popup-message",
                    key: randomMessage.value,
                    innerHTML: randomMessage.value
                  }, null, 8, _hoisted_4))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                (_unref(ads).isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[2] || (_cache[2] = [
                      _createElementVNode("div", null, "Loading response", -1),
                      _createElementVNode("div", { class: "loading-dots" }, [
                        _createElementVNode("span"),
                        _createElementVNode("span"),
                        _createElementVNode("span")
                      ], -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "response-message",
                      onClick: handleResponseClick
                    }, "Response received▶️"))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})